export default class CandidateResetSurveyHistory {
  id: string;

  reason: string;

  surveyName: string;

  createdBy: string;

  resetDate: string;

  constructor(data: any) {
    this.id = data.id || '';
    this.reason = data.reason || '';
    this.surveyName = data.surveyName || '';
    this.createdBy = data.createdBy || '';
    this.resetDate = data.resetDate || '';
  }
}
